import { allowStorage } from './allow.storage'

const PENDING_LOGOUT_KEY = 'logout-pending'

/**
 * Records that a logout started while the page was unloading.
 *
 * A logout during `beforeunload` cannot finish: the reload or close wins over its navigation to
 * `/api/auth/logout`, and its keepalive request races the next page's requests, which still carry
 * the auth cookies. The marker lets the next page load finish it (see {@link takePendingLogout}).
 */
export const markLogoutPending = (): void => {
  if (!allowStorage()) return

  localStorage.setItem(PENDING_LOGOUT_KEY, '1')
}

/**
 * Returns whether a logout is pending from a previous page and clears the marker, so the caller
 * finishes it exactly once.
 */
export const takePendingLogout = (): boolean => {
  if (!allowStorage() || localStorage.getItem(PENDING_LOGOUT_KEY) === null) return false

  localStorage.removeItem(PENDING_LOGOUT_KEY)

  return true
}
